import { useQueryShowUiProcedureType } from '@/hooks/query/use-query-procedure-type-tree';
import { cn, wrapQuote } from '@/lib/utils';
import { ProcedureTypeResponse } from '@/server/api/v1/procedure-type/type';
import { useTranslations } from 'next-intl';
import { memo } from 'react';

type BadgeGroupImplementSubjectProps = {
    types_Token?: string;
    hidePreName?: boolean;
};

/*
 * View thuần — KHÔNG tự gọi query. Nhận `procedureTypes` từ cha.
 * Dùng ở các trang render LẶP cho từng dòng bảng (vd: procedure-cust):
 * cha gọi `useQueryShowUiProcedureType()` MỘT lần rồi truyền xuống, tránh
 * mỗi dòng tạo 1 subscription + 1 lần `loopChild` riêng -> giảm tải re-render.
 */
const BadgeGroupImplementSubjectView = memo(function BadgeGroupImplementSubjectView({
    types_Token,
    hidePreName,
    procedureTypes,
}: BadgeGroupImplementSubjectProps & {
    procedureTypes: (ProcedureTypeResponse & { bg?: string; fg?: string })[];
}) {
    const transPage = useTranslations('ProcedureManagement'); // language của trang
    const transProcedureTypeManagement = useTranslations(
        'ProcedureTypeManagement'
    ); // language của trang
    const transDef = useTranslations('System'); // language dùng chung

    return (
        <>
            <div
                className={cn('font-bold text-primary', {
                    hidden: hidePreName,
                })}
            >
                {transPage('ProcedureManagement_ImplementObject')}:
            </div>
            <div className='gap-x-1 lg:flex'>
                {types_Token != undefined && types_Token.length > 0 ? (
                    procedureTypes.map((x) => (
                        <span
                            key={x.ID}
                            style={{ background: x.bg, color: x.fg }}
                            className={cn(
                                'truncate rounded-xl px-2 py-1 text-center text-xs font-bold leading-normal',
                                {
                                    hidden:
                                        !x.ValueStr ||
                                        x.ValueStr.length === 0 ||
                                        !types_Token.includes(
                                            wrapQuote(x.ValueStr)!
                                        ),
                                }
                            )}
                        >
                            {x.AppLanguageResourceCode &&
                            x.AppLanguageResourceCode.length > 0
                                ? transProcedureTypeManagement(
                                      x.AppLanguageResourceCode.toString() as any
                                  )
                                : x.Name}
                        </span>
                    ))
                ) : (
                    <span
                        className={cn(
                            'rounded-xl px-2 py-1 text-center text-xs font-medium leading-normal',
                            'bg-secondary text-secondary-foreground'
                        )}
                    >
                        {transDef('System_All')}
                    </span>
                )}
            </div>
        </>
    );
});

export { BadgeGroupImplementSubjectView };

/*
 * Wrapper tương thích ngược: tự gọi query nếu caller không truyền sẵn
 * `procedureTypes`. Các trang KHÔNG render lặp nhiều dòng có thể dùng cái này.
 * Trang render lặp (procedure-cust) nên dùng `BadgeGroupImplementSubjectView`
 * + truyền `procedureTypes` từ cha để tránh N subscriptions.
 */
export const BadgeGroupImplementSubject = memo(function BadgeGroupImplementSubject({
    types_Token,
    hidePreName,
}: BadgeGroupImplementSubjectProps) {
    const { data: apiProcedureType } = useQueryShowUiProcedureType();

    return (
        <BadgeGroupImplementSubjectView
            types_Token={types_Token}
            hidePreName={hidePreName}
            procedureTypes={apiProcedureType}
        />
    );
});
